import React, { useState, useMemo, useEffect } from "react";
import cssClasses from "../../Components/Leads/Leads.module.css";
import {
  getPopPlansForCP,
  getAopPlansForCP,
  upsertCPSignoff,
  getBaseBrokeragePlans,
} from "../../Services/SignOffs";
import {
  Box,
  Typography,
  Button,
  Card,
  Chip,
  Tabs,
  Tab,
  Divider,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  
  DialogActions,
  TextField,
  IconButton,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import { errorTost } from "../../Services/Toast";

const CPSignoffs = () => {
   let loggedInUser = {};
    loggedInUser = useSelector((state) => state.Auth.user);
    console.log("🚀 ~ file: CpSignOffs.jsx:24 ~ CPSignoffs ~ loggedInUser:", loggedInUser)
  const dispatch = useDispatch();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("Pending");
  const [expandedId, setExpandedId] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [acceptDialog, setAcceptDialog] = useState(false);
  const [rejectDialog, setRejectDialog] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewFromAccept, setPreviewFromAccept] = useState(false);

  // ✅ SINGLE CP ID METHOD
  const getCpId = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.cpId || null;
  };

  const counts = useMemo(() => {
    return {
      Pending: plans.filter((p) => p.status === "Pending").length,
      Accepted: plans.filter((p) => p.status === "Accepted").length,
      Rejected: plans.filter((p) => p.status === "Rejected").length,
    };
  }, [plans]);
  useEffect(() => {
    dispatch(action.activeMenu("cpsignoffs"));
  }, [dispatch]);

  const checkESignStatus = async (esignClientId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE}api/esign/status/${esignClientId}`,
      );

      const data = await res.json();
      console.log("Updated status:", data);
    } catch (err) {
      console.error("Status check failed:", err);
    }
  };

  useEffect(() => {
    const fetchPlans = async () => {
      const cpId = getCpId();
      if (!cpId) return;

      // ✅ PASS CP ID TO BOTH SERVICES
      const { data: popData } = await getPopPlansForCP(cpId);
      const { data: aopData } = await getAopPlansForCP(cpId);
      const { data: baseData } = await getBaseBrokeragePlans();
      let formattedPlans = [];

      // 🔵 POP
      if (popData) {
        const formattedPop = popData.map((plan) => ({
          id: plan.id,
          title: plan.name,
          type: "POP",
          status: plan.signoffStatus,
          docUrl: plan.docurl,
          project: plan.pop_scope_entities?.[0]?.Projects?.projectName || "-",
          wing: plan.pop_scope_entities?.[0]?.Wings?.wingName || "-",
          unit: plan.pop_scope_entities?.[0]?.Inventory?.unitNo || "",
          startDate: new Date(plan.start_date).toLocaleDateString(),
          endDate: new Date(plan.end_date).toLocaleDateString(),
          slabs:
            plan.pop_slabs?.map((slab) => ({
              name: `Slab ${slab.sort_order}`,
              start: slab.from_value,
              end: slab.to_value,
              reward: slab.percentage ? slab.percentage : slab.amount,
              type: slab.percentage ? "Percentage" : "Fixed",
            })) || [],
        }));
        console.log("formatted plans", formattedPlans);

        formattedPlans.push(...formattedPop);
      }

      // 🟣 AOP
      
      if (aopData) {
        const formattedAop = aopData.map((plan) => ({
          id: plan.id,
          title: `AOP ${plan.financial_year}`,
          type: "AOP",
          status: plan.signoffStatus,
          project: "All Projects",
          wing: "-",
          unit: "",
          docUrl: plan.docurl,  
          
          
          startDate: new Date(plan.sign_off_start_date).toLocaleDateString(),
          endDate: new Date(plan.sign_off_end_date).toLocaleDateString(),
          slabs:
            plan.aop_slabs?.map((slab) => ({
              name: `Slab ${slab.sort_order}`,
              start: slab.from_value,
              end: slab.to_value,
              reward: slab.percentage ? slab.percentage : slab.amount,
              type: slab.reward_type === "PERCENTAGE" ? "Percentage" : "Fixed",
              calculation:
                slab.calculation_basis === "COUNT" ? "Count" : "Value",
            })) || [],
        }));

        formattedPlans.push(...formattedAop);
      }

      // 🟢 BASE BROKERAGE (VIEW ONLY)
      if (baseData) {
        const formattedBase = baseData.map((plan) => ({
          id: plan.id,
          title: plan.name,
          type: "BASE",
          status: "Pending", // 👈 Always show in Accepted tab
          project:
            plan.base_brokerage_plan_projects?.[0]?.Projects?.projectName ||
            "-",
          wing: "-",
          unit: "",
          startDate: new Date(plan.start_date).toLocaleDateString(),
          endDate: plan.end_date
            ? new Date(plan.end_date).toLocaleDateString()
            : "No End Date",
          slabs: [
            {
              name: "Base Brokerage",
              start: "-",
              end: "-",
              reward:
                plan.calc_type === "Percentage"
                  ? `${plan.value}%`
                  : `₹${plan.value}`,
              type: plan.calc_type,
            },
          ],
        }));

        formattedPlans.push(...formattedBase);
      }

      setPlans(formattedPlans);
      setLoading(false);
    };

    fetchPlans();
  }, []);
  // On mount: if returning from eSign callback, immediately upsert Accepted signoff
  useEffect(() => {
    const pendingClientId = localStorage.getItem("cpEsignPendingClientId");
    const pendingPlanId = localStorage.getItem("cpEsignPendingPlanId");
    const pendingPlanType = localStorage.getItem("cpEsignPendingPlanType");
    if (!pendingClientId || !pendingPlanId || !pendingPlanType) return;

    const cpId = getCpId();
    if (!cpId) return;

    localStorage.removeItem("cpEsignPendingClientId");
    localStorage.removeItem("cpEsignPendingPlanId");
    localStorage.removeItem("cpEsignPendingPlanType");

    upsertCPSignoff({
      planId: pendingPlanId,
      planType: pendingPlanType,
      cpId,
      status: "Accepted",
    }).then(() => {
      handleStatusChange(pendingPlanId, "Accepted");
    });
  }, []);

  const handleESignInitialize = async () => {
    if (!selectedPlan) return;

    try {
      const cpId = getCpId();
      if (!cpId) {
        errorTost("Session expired. Please login again.");
        return;
      }
  //    const isLocalhost = window.location.hostname === "localhost";
  // const callbackUrl = isLocalhost
  //   ? "https://vj-cp-app-sandbox.web.app/cpsignoffs"
  //   : `${window.location.origin}/cpsignoffs`;
  const callbackUrl = "https://partnersandbox.vjerp.com/Home/CpSignOffs"; 

      const response = await fetch(
        `${process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE}api/cp-esign/initialize`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            planId: selectedPlan.id,
            planType: selectedPlan.type,
            cpId: cpId,
            callback_url: callbackUrl,
            configReason: "Contract1",
            fullName: loggedInUser.name || "CP User",
           mobileNumber: String(loggedInUser.contactNumber || "9999999999").trim(),
            userEmail:  loggedInUser.email || "",
          }),
        },
      );

      const data = await response.json();

      console.log("eSign Initialize Response:", data);

      if (response.ok && data.url) {
        if (data.clientId) {
          localStorage.setItem("cpEsignPendingClientId", data.clientId);
          localStorage.setItem("cpEsignPendingPlanId", selectedPlan.id);
          localStorage.setItem("cpEsignPendingPlanType", selectedPlan.type);
        }
        console.log("Redirecting to eSign page:", data.url);
        window.location.href = data.url;
      } else {
        errorTost(data.error || "eSign Initialization Failed");
      }
    } catch (error) {
      console.error("eSign Error:", error);
      errorTost("Error while initializing eSign");
    }
  };

  // const pollSignedDocument = (esignId) => {
  //   const interval = setInterval(async () => {
  //     try {
  //       const res = await fetch(
  //         `http://localhost:8050/get-signed-document/${esignId}`
  //       );

  //       if (!res.ok) return;

  //       const blob = await res.blob();

  //       if (blob.size > 0) {
  //         clearInterval(interval);

  //         const url = URL.createObjectURL(blob);
  //         window.open(url);

  //         errorTost("Signed PDF Generated Successfully");
  //       }
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   }, 5000);
  // };

  const handleStatusChange = (id, newStatus) => {
    setPlans((prevPlans) =>
      prevPlans.map((plan) =>
        plan.id === id ? { ...plan, status: newStatus } : plan,
      ),
    );
  };

  const filteredPlans = plans.filter((plan) => plan.status === tab);

  const formatIndian = (val) => {
    if (val === null || val === undefined || val === "-") return "-";
    const num = Number(val);
    if (isNaN(num)) return val;
    return num.toLocaleString("en-IN");
  };

  const statusConfig = {
    Pending:  { bg: "#fff8ed", color: "#b45309", border: "#fcd34d" },
    Accepted: { bg: "#f0fdf4", color: "#15803d", border: "#86efac" },
    Rejected: { bg: "#fff1f2", color: "#be123c", border: "#fda4af" },
  };

  const typeConfig = {
    POP:  { bg: "#eff6ff", color: "#1d4ed8" },
    AOP:  { bg: "#f5f3ff", color: "#6d28d9" },
    BASE: { bg: "#f0fdf4", color: "#15803d" },
  };

  return (
    <Box sx={{ height: "100vh", overflowY: "auto", overflowX: "hidden", p: { xs: 2, sm: 5 }, bgcolor: "#f8fafc" }}>
      <div className={cssClasses.headerTitle}>Signoffs</div>

      {/* Tab bar */}
      <Box
        display="flex"
        gap={1.5}
        mt={3}
        mb={4}
        sx={{ overflowX: "auto", pb: 0.5 }}
      >
        {["Pending", "Accepted", "Rejected"].map((label) => {
          const active = tab === label;
          const cfg = statusConfig[label];
          return (
            <Box
              key={label}
              onClick={() => setTab(label)}
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: { xs: 2, sm: 3 },
                py: { xs: 1, sm: 1.2 },
                borderRadius: "10px",
                border: `1.5px solid ${active ? cfg.border : "#e2e8f0"}`,
                bgcolor: active ? cfg.bg : "#fff",
                fontWeight: active ? 700 : 500,
                fontSize: { xs: "13px", sm: "15px" },
                color: active ? cfg.color : "#64748b",
                whiteSpace: "nowrap",
                transition: "all 0.15s",
                boxShadow: active ? `0 2px 8px ${cfg.border}55` : "none",
              }}
            >
              {label}
              <Box
                sx={{
                  minWidth: 22,
                  height: 22,
                  borderRadius: "6px",
                  bgcolor: active ? cfg.color : "#e2e8f0",
                  color: active ? "#fff" : "#64748b",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                  fontWeight: 700,
                  px: 0.5,
                }}
              >
                {counts[label]}
              </Box>
            </Box>
          );
        })}
      </Box>

      {/* Empty state */}
      {filteredPlans.length === 0 && (
        <Box textAlign="center" py={10} color="#94a3b8">
          <Typography fontSize={18} fontWeight={600} mb={1}>No {tab} Plans</Typography>
          <Typography fontSize={14}>Plans that are {tab.toLowerCase()} will appear here.</Typography>
        </Box>
      )}

      {filteredPlans.map((plan) => {
        const sCfg = statusConfig[plan.status] || statusConfig.Pending;
        const tCfg = typeConfig[plan.type] || typeConfig.BASE;
        return (
        <Card
          key={plan.id}
          sx={{
            borderRadius: "16px",
            mb: 3,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)",
            border: "1px solid #f1f5f9",
            overflow: "hidden",
          }}
        >
          {/* Colored top accent bar */}
          <Box sx={{ height: 4, bgcolor: sCfg.border }} />

          <Box p={{ xs: 2.5, sm: 3.5 }}>
            {/* Top row: title + status badge */}
            <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={1} mb={2}>
              <Typography fontWeight={700} fontSize={{ xs: 16, sm: 20 }} color="#1e293b" sx={{ flex: 1 }}>
                {plan.title}
              </Typography>
              <Box display="flex" gap={1} flexWrap="wrap">
                <Chip
                  label={plan.type}
                  size="small"
                  sx={{ fontSize: "12px", fontWeight: 600, bgcolor: tCfg.bg, color: tCfg.color, border: "none" }}
                />
                <Chip
                  label={plan.status}
                  size="small"
                  sx={{ fontSize: "12px", fontWeight: 600, bgcolor: sCfg.bg, color: sCfg.color, border: `1px solid ${sCfg.border}` }}
                />
              </Box>
            </Box>

            {/* Info row */}
            <Box
              display="flex"
              flexWrap="wrap"
              gap={{ xs: 1.5, sm: 3 }}
              mb={2.5}
              p={1.5}
              bgcolor="#f8fafc"
              borderRadius="10px"
            >
              <Box>
                <Typography fontSize={11} color="#94a3b8" fontWeight={600} textTransform="uppercase" letterSpacing={0.5}>Project</Typography>
                <Typography fontSize={{ xs: 13, sm: 14 }} fontWeight={500} color="#374151">{plan.project}</Typography>
              </Box>
              <Box>
                <Typography fontSize={11} color="#94a3b8" fontWeight={600} textTransform="uppercase" letterSpacing={0.5}>Wing</Typography>
                <Typography fontSize={{ xs: 13, sm: 14 }} fontWeight={500} color="#374151">{plan.wing}</Typography>
              </Box>
              {plan.unit && (
                <Box>
                  <Typography fontSize={11} color="#94a3b8" fontWeight={600} textTransform="uppercase" letterSpacing={0.5}>Unit</Typography>
                  <Typography fontSize={{ xs: 13, sm: 14 }} fontWeight={500} color="#374151">{plan.unit}</Typography>
                </Box>
              )}
              <Box>
                <Typography fontSize={11} color="#94a3b8" fontWeight={600} textTransform="uppercase" letterSpacing={0.5}>Duration</Typography>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CalendarTodayOutlinedIcon sx={{ fontSize: 13, color: "#64748b" }} />
                  <Typography fontSize={{ xs: 13, sm: 14 }} fontWeight={500} color="#374151">
                    {plan.startDate} – {plan.endDate}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Action buttons row */}
            <Box display="flex" flexWrap="wrap" gap={1.5} alignItems="center" justifyContent="space-between">
              <Box display="flex" flexWrap="wrap" gap={1}>
                {plan.type !== "BASE" && (
                  <>
                    {tab === "Pending" && (
                      <>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<CheckCircleOutlineIcon />}
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: { xs: "12px", sm: "14px" },
                        px: { xs: 2, sm: 2.5 },
                        borderRadius: "8px",
                        bgcolor: "#16a34a",
                        "&:hover": { bgcolor: "#15803d" },
                        boxShadow: "0 2px 8px rgba(22,163,74,0.3)",
                      }}
                      onClick={() => { setSelectedPlanId(plan.id); setAcceptDialog(true); }}
                    >
                      Accept
                    </Button>

                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      startIcon={<HighlightOffIcon />}
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: { xs: "12px", sm: "14px" },
                        px: { xs: 2, sm: 2.5 },
                        borderRadius: "8px",
                      }}
                      onClick={() => { setSelectedPlanId(plan.id); setRejectDialog(true); }}
                    >
                      Reject
                    </Button>
                      </>
                    )}

                    <Button
                      variant="outlined"
                      size="small"
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: { xs: "12px", sm: "14px" },
                        px: { xs: 2, sm: 2.5 },
                        borderRadius: "8px",
                        borderColor: "#cbd5e1",
                        color: "#475569",
                        "&:hover": { borderColor: "#94a3b8", bgcolor: "#f8fafc" },
                      }}
                      onClick={() => { setSelectedPlan(plan); setPreviewUrl(plan.docUrl); setPreviewFromAccept(false); setPreviewOpen(true); }}
                    >
                      Preview
                    </Button>
                  </>
                )}
              </Box>

              {plan.slabs?.length > 0 && (
                <Button
                  size="small"
                  endIcon={expandedId === plan.id ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  onClick={() => setExpandedId(expandedId === plan.id ? null : plan.id)}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: { xs: "12px", sm: "14px" },
                    color: "#3b82f6",
                    px: 1.5,
                    borderRadius: "8px",
                    "&:hover": { bgcolor: "#eff6ff" },
                  }}
                >
                  View Slabs
                </Button>
              )}
            </Box>
          </Box>

          {/* Slab section */}
          <Collapse in={expandedId === plan.id}>
            <Divider sx={{ borderColor: "#f1f5f9" }} />
            <Box p={{ xs: 2, sm: 3 }} bgcolor="#fafbfc">
              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight={700} color="#64748b" textTransform="uppercase" letterSpacing={0.8} mb={2}>
                Commission Slabs
              </Typography>

              {/* Slab header */}
              <Box
                display="grid"
                gridTemplateColumns={plan.type === "BASE" ? "2fr 1fr 1fr" : "1.5fr 1fr 1fr 1fr 1fr"}
                px={2}
                py={1}
                bgcolor="#e2e8f0"
                borderRadius="8px"
                mb={1}
              >
                {plan.type === "BASE" ? (
                  <>
                    <Typography fontSize={{ xs: 11, sm: 13 }} fontWeight={700} color="#475569">Slab Name</Typography>
                    <Typography fontSize={{ xs: 11, sm: 13 }} fontWeight={700} color="#475569">
                      {plan.slabs?.[0]?.type === "Percentage" ? "Percentage (%)" : "Fixed Amount (₹)"}
                    </Typography>
                    <Typography fontSize={{ xs: 11, sm: 13 }} fontWeight={700} color="#475569">Type</Typography>
                  </>
                ) : (
                  <>
                    <Typography fontSize={{ xs: 11, sm: 13 }} fontWeight={700} color="#475569">Slab Name</Typography>
                    <Typography fontSize={{ xs: 11, sm: 13 }} fontWeight={700} color="#475569">
                      {plan.slabs?.[0]?.calculation === "Count" ? "From Agreements" : "From Value"}
                    </Typography>
                    <Typography fontSize={{ xs: 11, sm: 13 }} fontWeight={700} color="#475569">
                      {plan.slabs?.[0]?.calculation === "Count" ? "To Agreements" : "To Value"}
                    </Typography>
                    <Typography fontSize={{ xs: 11, sm: 13 }} fontWeight={700} color="#475569">
                      {plan.slabs?.[0]?.type === "Percentage" ? "Percentage (%)" : "Fixed Amount (₹)"}
                    </Typography>
                    <Typography fontSize={{ xs: 11, sm: 13 }} fontWeight={700} color="#475569">Type</Typography>
                  </>
                )}
              </Box>

              {/* Slab rows */}
              {plan.slabs?.map((slab, index) => (
                <Box
                  key={index}
                  display="grid"
                  gridTemplateColumns={plan.type === "BASE" ? "2fr 1fr 1fr" : "1.5fr 1fr 1fr 1fr 1fr"}
                  px={2}
                  py={1.2}
                  bgcolor={index % 2 === 0 ? "#fff" : "#f8fafc"}
                  borderRadius="8px"
                  mb={0.5}
                  sx={{ border: "1px solid #f1f5f9" }}
                >
                  {plan.type === "BASE" ? (
                    <>
                      <Typography fontSize={{ xs: 12, sm: 14 }} color="#374151">{slab.name}</Typography>
                      <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight={600} color="#1e293b">
                        {slab.type === "Percentage"
                          ? `${slab.reward.toString().replace("%", "")}%`
                          : `₹${formatIndian(slab.reward)}`}
                      </Typography>
                      <Chip label={slab.type} size="small" sx={{ fontSize: "11px", height: 22, bgcolor: tCfg.bg, color: tCfg.color, width: "fit-content" }} />
                    </>
                  ) : (
                    <>
                      <Typography fontSize={{ xs: 12, sm: 14 }} color="#374151">{slab.name}</Typography>
                      <Typography fontSize={{ xs: 12, sm: 14 }} color="#374151">{formatIndian(slab.start)}</Typography>
                      <Typography fontSize={{ xs: 12, sm: 14 }} color="#374151">{formatIndian(slab.end)}</Typography>
                      <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight={600} color="#1e293b">
                        {slab.type === "Percentage" ? `${slab.reward}%` : `₹${formatIndian(slab.reward)}`}
                      </Typography>
                      <Chip label={slab.type} size="small" sx={{ fontSize: "11px", height: 22, bgcolor: tCfg.bg, color: tCfg.color, width: "fit-content" }} />
                    </>
                  )}
                </Box>
              ))}
            </Box>
          </Collapse>
        </Card>
        );
      })}
      {/* Accept Dialog */}
      <Dialog
        open={acceptDialog}
        onClose={() => setAcceptDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 2,
          },
        }}
      >
        <DialogTitle sx={{ fontSize: 22, fontWeight: 700 }}>
          Confirm Acceptance
        </DialogTitle>

        <DialogContent>
          <Typography fontSize={18}>
            To accept this plan, you need to complete the eSign process. Click "Proceed to eSign" to preview the document and sign it digitally.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ p: 3 }}>
          <Button
            size="large"
            sx={{ fontSize: 16, px: 4, py: 1.5 }}
            onClick={() => setAcceptDialog(false)}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            size="large"
            sx={{ fontSize: 16, px: 4, py: 1.5 }}
            onClick={() => {
              const plan = plans.find((p) => p.id === selectedPlanId);
              if (!plan) return;

              setAcceptDialog(false);
              setSelectedPlan(plan);
              setPreviewUrl(plan.docUrl);
              setPreviewFromAccept(true);
              setPreviewOpen(true);
            }}
          >
            Proceed to eSign
          </Button>
        </DialogActions>
      </Dialog>
      {/* Reject Dialog */}
      <Dialog
        open={rejectDialog}
        onClose={() => setRejectDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 2,
          },
        }}
      >
        <DialogTitle sx={{ fontSize: 22, fontWeight: 700 }}>
          Reject Plan
        </DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            multiline
            rows={5}
            label="Rejection Reason"
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            sx={{
              mt: 2,
              "& .MuiInputBase-input": {
                fontSize: 16, // 🔥 increased textarea text size
              },
              "& .MuiInputLabel-root": {
                fontSize: 16, // 🔥 increased label size
              },
            }}
          />
        </DialogContent>

        <DialogActions sx={{ p: 3 }}>
          <Button
            size="large"
            sx={{ fontSize: 16, px: 4, py: 1.5 }}
            onClick={() => setRejectDialog(false)}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            size="large"
            sx={{ fontSize: 16, px: 4, py: 1.5 }}
            disabled={!rejectReason.trim()}
            onClick={async () => {
              const cpId = getCpId();
              if (!cpId) {
                alert("Session expired. Please login again.");
                return;
              }

              const selectedPlan = plans.find((p) => p.id === selectedPlanId);

              // ✅ 1. Update UI first
              handleStatusChange(selectedPlanId, "Rejected");

              // ✅ 2. Close dialog
              setRejectDialog(false);
              setRejectReason("");

              // ✅ 3. Then call backend
              await upsertCPSignoff({
                planId: selectedPlanId,
                planType: selectedPlan.type,
                cpId,
                status: "Rejected",
                reason: rejectReason,
              });
            }}
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>
      {/* Dialogs remain same as your previous version */}
      {/* (kept unchanged intentionally) */}
      {/* Preview PDF Dialog */}
      <Dialog
        open={previewOpen}
        onClose={() => { setPreviewOpen(false); setPreviewFromAccept(false); }}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ fontSize: 22, fontWeight: 700, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Plan Preview
          <IconButton onClick={() => setPreviewOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ height: "80vh" }}>
          {previewUrl ? (
            <iframe
              src={previewUrl}
              title="PDF Preview"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          ) : (
            <Typography>No document available</Typography>
          )}
        </DialogContent>

        {previewFromAccept && (
          <DialogActions>
            <Button variant="contained" onClick={handleESignInitialize}>
              eSign
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </Box>
  );
};

export default CPSignoffs;
